import {Component, ViewChild} from '@angular/core';
import {BlockBaseComponent} from "../block-base/block-base.component";
import {StoreSelectorsService} from "../../../../services";
import {MatDialog} from "@angular/material/dialog";
import {TranslocoService} from "@ngneat/transloco";
import {TimeCounter} from "../../../../components/input-time/input-time.component";
import {dateUnixToString, jsDateToEpoch, TOMORROW} from "../../../../common";
import {DynamicFormComponent} from "../../../../components/dynamics/dynamic-form/dynamic-form.component";

/** date format allows to use the native js Date() with easy string formatting
 * https://github.com/felixge/node-dateformat
 * const dateObject:Date = new Date(Number(unixEpoc));
 * example: const time = dateFormat(dateObject, "dddd, mmmm dS, yyyy, h:MM:ss TT");
 **/
import dateFormat from "dateformat";

@Component({
    selector: 'app-scene-block-counter',
    templateUrl: './block-countdown.component.html',
    styleUrls: ['./block-countdown.component.scss']
})
export class BlockCountdownComponent extends BlockBaseComponent {

    @ViewChild('dynamicFormComponent')
    dynamicFormComponent: DynamicFormComponent;

    constructor(private translocoService: TranslocoService, public override storeSelector: StoreSelectorsService, public override dialog: MatDialog) {
        super(storeSelector, dialog);
    }

    override initRegisterDynamic() {
        this.uiConfigInit = [
            {
                type: "input",
                value: "%D days and %H:%M:%S Left!!!",
                label: this.translocoService.translate('general.formatText', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                restrictChar: 'basic0',
                name: "formatText",
                hideMe: false,
                storePath: 'Data[0].Countdown[0].$.formatText'
            },
            {
                type: "select",
                label: this.translocoService.translate('general.mode', {}, this.translocoService.getActiveLang()),
                name: "mode",
                hideMe: false,
                value: "Duration",
                options: ["Duration", "Date"],
                storePath: 'Data[0].Countdown[0].$.mode'
            },
            {
                type: "input",
                label: this.translocoService.translate('general.startDate', {}, this.translocoService.getActiveLang()),
                name: "finalCalendar",
                value: TOMORROW,
                inputType: "date",
                ignoreMissingValue: true,
                storePath: 'Data[0].Countdown[0].$.finalDate'
            },
            {
                type: "input",
                hideMe: false,
                label: this.translocoService.translate('general.startDate', {}, this.translocoService.getActiveLang()),
                name: "finalDate",
                value: TOMORROW,
                inputType: "time_stepper",
                ignoreMissingValue: true,
                storePath: 'Data[0].Countdown[0].$.finalDate'
            },
            {
                type: "input",
                hideMe: false,
                label: this.translocoService.translate('general.countdownTime', {}, this.translocoService.getActiveLang()),
                name: "duration",
                value: TOMORROW,
                inputType: "time_stepper",
                storePath: 'Data[0].Countdown[0].$.duration'
            }
            // ,{
            //     type: "checkbox",
            //     value: '1',
            //     label: this.translocoService.translate('general.gpu', {}, this.translocoService.getActiveLang()),
            //     name: "gpu",
            //     storePath: '$.gpu'
            // }
        ];
    }

    override componentStoreUpdates() {
        this.dynamicFormComponent.ignoreValidation = true;
        super.componentStoreUpdates();
        switch (this.sceneItem.Data[0].Countdown[0].$.mode) {
            case 'Date': {
                this.setUiConfigHide('finalDate', false);
                this.setUiConfigHide('duration', true);
                this.setUiConfigHide('finalCalendar', false);
                let unix = Number(this.sceneItem.Data[0].Countdown[0].$.finalDate);
                unix = isNaN(unix) ? TOMORROW : unix;
                const date = new Date(Number(unix));
                const time = new TimeCounter(dateFormat(date, "HH"), dateFormat(date, "MM"), dateFormat(date, "ss"), unix);
                this.setFormValue('finalDate', time);
                this.setFormValue('finalCalendar', dateUnixToString(String(time.unix)));
                break;
            }
            case 'Duration': {
                this.setUiConfigHide('finalDate', true);
                this.setUiConfigHide('duration', false);
                this.setUiConfigHide('finalCalendar', true);
                let unix = Number(this.sceneItem.Data[0].Countdown[0].$.duration);
                unix = isNaN(unix) ? 40953 : unix;
                const dateObject = new Date(Number(unix) * 1000);
                const s = dateObject.toUTCString().replace('GMT', '');
                const date = new Date(s);
                const time = new TimeCounter(dateFormat(date, "HH"), dateFormat(date, "MM"), dateFormat(date, "ss"), unix);
                this.setFormValue('duration', time);
                // this.setFormValue('finalCalendar', dateUnixToString(String(time.unix)));
                break;
            }
        }
    }

    override submit(formValues) {
        let setDate;
        let epoc;
        if (formValues.finalCalendar instanceof Date) {
            const d = dateFormat(formValues.finalCalendar, "dd, mmmm, yyyy");
            setDate = `${d} ${formValues.finalDate.hours}:${formValues.finalDate.minutes}:${formValues.finalDate.seconds}`;
            const newDate = new Date(setDate);
            epoc = jsDateToEpoch(newDate) * 1000;
        } else {
            switch (formValues.mode) {
                case 'Date': {
                    if (!formValues.finalDate) return;
                    setDate = `${formValues.finalCalendar} ${formValues.finalDate.hours}:${formValues.finalDate.minutes}:${formValues.finalDate.seconds}`;
                    const newDate = new Date(setDate);
                    epoc = jsDateToEpoch(newDate) * 1000;
                    break;
                }
                case 'Duration': {
                    if (!formValues.duration) return;
                    const h = Number(formValues.duration.hours) * 60 * 60;
                    const m = Number(formValues.duration.minutes) * 60;
                    const s = Number(formValues.duration.seconds);
                    epoc = h + m + s;
                    break;
                }
            }
        }
        const submitData = {
            "formatText": formValues.formatText,
            "mode": formValues.mode,
            "finalDate": epoc,
            "duration": epoc
        };
        super.submit(submitData);
    }
}

